import { Route, Routes, useLocation, useNavigate,Navigate  } from "react-router-dom";
import Home from "../Home";
import About from "../About";
import Contact from "../Contact";
import NotFound from "../NotFound";
import Main from "../Main/Main";
import Wheel from "../Wheel/Wheel";
import Login from "../Main/Components/Login";
import Novedades from "../Main/Components/Novedades/Novedades";
import {AuthProvider} from '../Main/Components/Context/authContext';
import Attendance from "../Attendance/Attendance";
import NextEvents from "../NextEvents/NextEvents";
import Documentation from "../Documentation/Documentation";
import Tournaments from "../Tournaments/Tournaments"
import Ranking  from "../Ranking/Ranking";
const RoutesMoviSoftware = () => {
  return (
    <AuthProvider>
    <Routes>
    <Route path="/" element={<Navigate to="/main" />} />
      <Route path="/login" element={<Login />} exact />
      <Route  path="/main" element={<Main />} exact >
      <Route path="/main" element={<Home />} exact />
      <Route path="/main/about" element={<About />} exact />
      <Route path="/main/contact" element={<Contact />} exact />
      <Route path="/main/wheel" element={<Wheel />} exact />
      <Route path="/main/novedades" element={<Novedades />} exact />
      <Route path="/main/attendance" element={<Attendance />} exact />
      <Route path="/main/nextEvents" element={<NextEvents />} exact />
      <Route path="/main/documentation" element={<Documentation />} exact />
      <Route path="/main/tournament" element={<Tournaments />} exact />
      <Route path="/main/ranking" element={<Ranking />} exact />
      <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </AuthProvider>
  );
};
export default RoutesMoviSoftware;
